import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  placeholder: {
    id: 'selectField.placeholder',
    defaultMessage: 'Valitse...',
  },
})
